module.exports = __webpack_public_path__ + "img/header-cy.e00310e7.jpg";